import React from "react";
import { Accordion, Container } from "react-bootstrap";
import "./Terms.css"; // We'll create this CSS file


const TermsSection = () => {
  return (
    <Container className="my-5">
      <h2 className="terms-heading mb-4">Terms of Service & Refund Policy</h2>
      <Accordion defaultActiveKey="0" flush>
        {/* Introduction */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Introduction</Accordion.Header>
          <Accordion.Body>
            Welcome to EZMedServ LLC (“we,” “our,” “us”). By accessing or using our
            website and services, you agree to comply with these Terms of Service.
            If you do not agree, please do not use our site or services.
          </Accordion.Body>
        </Accordion.Item>

        {/* Services */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Services</Accordion.Header>
          <Accordion.Body>
            EZMedServ LLC provides consulting, business, sales, and medical billing
            support. All services are subject to eligibility, verification, and final
            approval by EZMedServ LLC. We reserve the right to refuse or discontinue
            services at our discretion.
          </Accordion.Body>
        </Accordion.Item>

        {/* Service Fees */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Service Fees</Accordion.Header>
          <Accordion.Body>
            All service fees are determined on a <strong>NET basis</strong>. Clients
            are responsible for declaring, paying, and bearing all taxes, duties,
            levies, or other financial obligations in accordance with local laws.
          </Accordion.Body>
        </Accordion.Item>

        {/* Payment Methods */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Payment Methods & Credit Cards</Accordion.Header>
          <Accordion.Body>
            We provide convenient payment options including Bank Transfers, PayPal,
            Credit Cards (Visa, MasterCard, AmEx, Discover), Cryptocurrencies, and
            Electronic wallets.
            <br />
            <strong>Credit Card Payments:</strong> Payments are processed securely
            via third-party providers. By submitting a payment, you authorize EZMedServ
            LLC to charge the full amount. Any disputes must be raised directly with
            EZMedServ LLC before contacting your bank.
          </Accordion.Body>
        </Accordion.Item>

        {/* Refund Policy */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Refund Policy</Accordion.Header>
          <Accordion.Body>
            Refunds are considered only if services are <strong>not delivered as
            described</strong>. Refunds may be refused if the client provides
            inaccurate information, changes services without approval, or if
            suspicion of fraud exists.
            <br />
            Refunds, if granted, are limited to the remaining unspent service fee and
            do not include taxes, fees, or costs already incurred.
            <br />
            Refunds are issued only to the original payment method and may take 5–20
            business days.
          </Accordion.Body>
        </Accordion.Item>

        {/* Disputes */}
        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Disputes</Accordion.Header>
          <Accordion.Body>
            If you have concerns regarding charges, contact EZMedServ LLC directly
            before initiating a dispute. We reserve the right to deny chargebacks or
            disputes if a reasonable resolution attempt is not made.
          </Accordion.Body>
        </Accordion.Item>

        {/* Limitation of Liability */}
        <Accordion.Item eventKey="6">
          <Accordion.Header>7. Limitation of Liability</Accordion.Header>
          <Accordion.Body>
            EZMedServ LLC is not liable for indirect, incidental, or consequential
            damages. Total liability is limited to the amount paid for services.
          </Accordion.Body>
        </Accordion.Item>

        {/* Contact */}
        <Accordion.Item eventKey="7">
          <Accordion.Header>8. Contact Information</Accordion.Header>
          <Accordion.Body>
            For questions regarding Terms, Service, Payments, or Refunds:
            <br />
            📧 Email: info@ezmedserv.com
            <br />
            📞 Phone: 1 (614) 706-6175
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default TermsSection;